import QRCode from 'qrcode';

// QRコードのベースURL
const BASE_URL = window.location.origin;

// QRコードの生成（席番号を含むURL）
export async function generateQRCode(seatNumber: number): Promise<string> {
  try {
    const url = `${BASE_URL}/seat/${seatNumber}`;
    return await QRCode.toDataURL(url);
  } catch (error) {
    console.error('Error generating QR code:', error);
    throw error;
  }
}

// 席番号と名前のQRコード画像生成（印刷用）
export async function generatePrintableQRCode(seatNumber: number): Promise<string> {
  try {
    const url = `${BASE_URL}/seat/${seatNumber}`;
    return await QRCode.toDataURL(url, {
      width: 300,
      margin: 2,
    });
  } catch (error) {
    console.error('Error generating printable QR code:', error);
    throw error;
  }
} 